<template>
    <div></div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Utils from "../Utils.vue";
    import CatalogUtils from "../catalog/CatalogUtils.vue";
    import {scroller} from 'vue-scrollto/src/scrollTo'
    const scrollerTo = scroller();

    export default {
        name: "ProductCard",
        data: function() {
            return {
                size: 0,
                isThinDough: false,
                isActive: false,
                headerMarginTop: 0,
                timeoutID: 0,
                isSelectedSauce: false,
                selectedSauce: {},
                addedToBasket: false,
                voteButtonProcessing: false,
                isAvailable: true,
                selectedProductOffer: null
            }
        },
        methods: {
            addToBasket: function () {
                const component = this;
                if(component.isOpenOrder()){
                  return false;
                }
                const product = this.product;
                const doughType = this.isThinDough ? 'thin' : 'thick';
                const offer = this.prepareBasketOffer(product, this.selectedOffer, doughType);
                this.$store.dispatch({
                    type: 'order/addToBasket',
                    offer: offer,
                }).then( function () {
                    component.calculateDiscount();
                });

                if(offer.only_pickup){
                    this.$store.dispatch({
                        type: 'order/changeDeliveryType',
                        isDelivery: false,
                    });
                }
                this.addedToBasket = true;
                const el = this;
                setTimeout(function () {
                    el.addedToBasket = false;
                }, 400);
            },
            changeDoughType(isThinDough){
                this.isThinDough = isThinDough;
            },
            chooseSauceOffer(sauce){
                if(!sauce.available){
                  return false;
                }
                this.chooseOffer(sauce);
            },
            chooseOffer(offer){
                this.selectedProductOffer = offer;
                this.$store.commit('catalog/setSelectedOffer', offer);
                this.isAvailable = offer.available;
            },
            choosePizzaSize(offer){
                if(!offer.available){
                  return false;
                }
                let selectedOffer = offer;
                this.size = offer.size;
                this.isActive = true;
                selectedOffer.dough_available = parseInt(offer.size) > 25;
                this.$store.commit('catalog/setSelectedOffer', selectedOffer);

                let screenWidth = parseInt(window.innerWidth);
                if(screenWidth >= 920 && this.$refs.footer !== undefined) {
                    this.headerMarginTop = '-50%';
                }
            },
            chooseProduct(){
                this.isActive = true;
                const product = this.product;
                const selectedOffer = {};
                if(product.offers.length === 0) {
                  this.$store.commit('catalog/setSelectedOffer', this.prepareSelectedProductWithoutOffer(product));
                }else{
                  Object.assign(selectedOffer, this.prepareSelectedProductWithOffer(product));
                  this.$store.commit('catalog/setSelectedOffer', selectedOffer);
                  this.isAvailable = selectedOffer.available;
                }

                let screenWidth = parseInt(window.innerWidth);
                if(screenWidth >= 920 && this.$refs.footer !== undefined) {
                    this.headerMarginTop = parseInt(this.$refs.footer.clientHeight) * -1;
                }
            },
            disactiveCard(){
                const el = this;
                this.timeoutID = setTimeout(function () {
                    el.isActive = false;
                }, 1500);
            },
            stopDisactiveCard(){
                this.timeoutID ? clearTimeout(this.timeoutID) : false;
            },
            chooseSauce(sauce){
              if(!sauce.available){
                return false;
              }
              this.selectedSauce = sauce;
              this.isSelectedSauce = true;
            },
            setVote(){
                if(!this.isAuthorize){
                    return false;
                }
                const product_id = this.product.id;
                const group_id = this.product.group_id;
                const user_id = this.userInfo.id;
                const vote = this.userVote === 0 ? 1 : -1;
                const productVote = {
                    group_id: group_id,
                    product_id: product_id,
                    user_id: user_id,
                    vote: vote,
                };
                if(this.voteButtonProcessing === false) {
                    this.voteButtonProcessing = true;
                    this.sendRequest('set-vote', {
                        product_id: product_id,
                        user_id: user_id
                    }).then(response => {
                        this.voteButtonProcessing = false;
                        const result = response.data;
                        if (result.status === 'success') {
                            const votes = result.total_vote;
                            Object.assign(productVote, {votes: votes});
                            this.$store.dispatch({
                                type: 'catalog/setVote',
                                productVote: productVote,
                                votes: votes,
                            });
                            this.$store.dispatch({
                                type: 'user/setVote',
                                productVote: productVote
                            });
                        }
                    });
                }
            },
            openLargeCard: function (catalogElement) {
              const product = catalogElement.element;
              const component = this;
              component.setMeta(product);
              const anchor = "#" + component.addAnchor(product);
              if(component.isSizeMd){
                scrollerTo(anchor, 500, {offset: -300});
              }else {
                component.$store.commit('catalog/setSelectedProductLargeCard', catalogElement);
                if (product.offers.length > 0) {
                  component.chooseOffer(component.getProductSelectedOffer(product.offers));
                } else {
                  component.chooseProduct();
                }
              }
            },
            openShareModal: function (share_id){
              this.isOpenShareModal = true;
              const share = this.productShares[share_id];
              this.productShare = {'title': share.NAME, 'description': share.DETAIL_TEXT};
            },
            optionsTitle: function(product){
              if(product.options_phrase_code !== undefined && product.options_phrase_code !== null){
                return this.phrases[product.options_phrase_code];
              }else{
                let title = this.phrases.PRODUCT_CHOOSE_TASTE;

                if(product.group === 'pizza'){
                  title = this.phrases.PRODUCT_CRUST_THICKNESS
                }

                if(product.group === 'sauce'){
                  title = this.phrases.PRODUCT_CHOOSE_DIP
                }

                if(product.group === 'drinks'){
                  title = this.phrases.PRODUCT_CHOOSE_VOLUME;
                }
                return title;
              }
            },
            getPrice: function (product, offerId){
              if(offerId !== undefined && product.offers.length > 0){
                const offer = product.offers.find((item) => item.id === offerId);
                if(offer !== undefined) {
                  return offer.price;
                }
              }
              return product.price_from;
            },
            getWeight: function (product, offerId){
              if(product.offers.length > 0){
                const offer = product.offers.find((item) => item.id === offerId);
                return (offer !== undefined) ? offer.weight : product.offers[0].weight;
              }
              return product.weight;
            },
            getPizzaWeight: function (product, offerId) {
              const offer = product.offers.find((item) => item.id === offerId);
              if(offer !== undefined) {
                if (offer.pizza_weight_thin == null && offer.pizza_weight_thick == null) {
                  return (offer.weight !== undefined && offer.weight !== null) ? offer.weight : product.weight;
                }
                return (offer.pizza_weight_thin !== null && this.isThinDough) ? offer.pizza_weight_thin : offer.pizza_weight_thick;
              }else{
                return this.getWeight(product, offerId);
              }
            },
            getProductSelectedOffer: function (productOffers, selectedProductOffer){
              const foundOffer = !this.isEmpty(selectedProductOffer) ?
                  productOffers.filter(o => o.id === selectedProductOffer.id) : [];
              return foundOffer.length ? foundOffer.pop() : productOffers[0];
            }
        },
        computed:{
            isPizza: function () {
                return this.product.group === 'pizza';
            },
            isSalad: function () {
                return this.product.group === 'salad';
            },
            isSauce: function () {
                return this.product.group === 'sauce';
            },
            isSnack: function () {
              return this.product.group === 'snack';
            },
            isCake: function () {
              return this.product.group === 'cake';
            },
            isDrinks: function () {
              return this.product.group === 'drinks';
            },
            isGift: function () {
              return this.product.group === 'gift';
            },
            consist: function () {
              return (this.selectedOffer.consist !== null && this.selectedOffer.consist !== undefined) ? this.selectedOffer.consist : this.product.consist;
            },
            ...mapGetters('user', {
                userInfo: 'getInfo',
                userVotes: 'getVotes',
                isAuthorize: 'isAuthorize'
            }),
            ...mapGetters('app', {
                phrases: 'getPhrases'
            }),
            ...mapGetters('catalog', {
                sauces: 'getSaucesModifiers',
                selectedOffer: 'getSelectedOffer',
                productShares: 'getProductShares',
            }),
            userVote: function () {
                const product_id = this.product.id;
                return (this.userVotes.find(id => parseInt(id) === parseInt(product_id))) ? 1 : 0;
            },
            isOpenShareModal: {
              get() {
                return this.$store.state.catalog.isOpenShareModal;
              },
              set(value) {
                this.$store.commit('catalog/setIsOpenShareModal', value);
              }
            },
            productShare: {
              get() {
                return this.$store.state.catalog.getProductShare;
              },
              set(value) {
                this.$store.commit('catalog/setProductShare', value);
              }
            },
            productSmallCardImage: function (){
                return (this.isActive || this.isEmpty(this.product.image))
                    ? this.productImage : this.product.image;
            },
            productImage: function (){
                const productImage = this.product.image;
                if(this.product.offers.length || this.isEmpty(productImage)){
                    const selectedOffer = this.getProductSelectedOffer(this.product.offers, this.selectedProductOffer);
                    if(!this.isEmpty(selectedOffer.image)){
                        return selectedOffer.image;
                    }
                }
                return productImage;
            }
        },
        mixins: [Utils, CatalogUtils],
    }
</script>

<style scoped>

</style>
